<div class="flex gap-2 h-full">
  <div class="flex-1 h-full overflow-hidden">
    <p-tree
      (onNodeSelect)="onNodeSelect($event)"
      [filter]="true"
      [value]="treeNodes"
      class="w-full h-full"
      filterPlaceholder=""
      scrollHeight="flex"
      selectionMode="single"></p-tree>
  </div>

  <div class="flex-1 h-full overflow-hidden">
    @if (selectedProfil) {
      <p-tabs [(value)]="activeTab">
        <p-tablist>
          <p-tab value="massnahmen">{{ 'CHOP_KATALOGE.STANDARD_MASSNAHMEN' | translate }}</p-tab>
          <p-tab value="betriebsvariablen">{{ 'CHOP_KATALOGE.BETRIEBSVARIABLEN' | translate }}</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="massnahmen">
            <app-table
              [columns]="massnahmenColumns"
              [value]="massnahmenRows"
              class="h-auto! inline!"
              sortField="tacsId"></app-table>
          </p-tabpanel>
          <p-tabpanel value="betriebsvariablen">
            <app-table
              [columns]="betriebsVariableColumns"
              [value]="betriebsVariableRows"
              class="h-auto! inline!"
              sortField="tacsCode">
              <ng-template
                (onClick)="showAddBetriebsVariableDialog()"
                appToolbarButton
                icon="fal fa-plus"
                labelKey="CHOP_KATALOGE.ADD_BETRIEBSVARIABLE"></ng-template>
              <ng-template
                (onClick)="removeBetriebsVariable($event.row)"
                appActionButton
                icon="fal fa-trash"
                labelKey="ACTIONS.DELETE"
                type="danger"></ng-template>
            </app-table>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    } @else {
      <p class="p-2">{{ 'CHOP_KATALOGE.SELECT_PROFIL' | translate }}</p>
    }
  </div>
</div>
